import { fetch, setTokens } from '@/utils/fetch'
import { ucur } from '@/utils/env'

const origin = `${window.location.origin}${window.location.pathname}`
const prefix = '../../'

/**
 * 通过 sso 回跳之后提供的参数换取 access_token
 * @param {string} token
 */
export const apiSsoAccessToken = (params: any) =>
  fetch.get(`${prefix}auth/v1/accessToken`, { params })

/**
 * 获取用户信息
 *
 */
export const getUserInfo = () =>
  fetch.get(`${prefix}auth/v1/user/info`, {
    params: { origin },
  })

/**
 * 退出登录
 *
 */
export const logout = () => {
  const entryObject = JSON.parse(localStorage.getItem('channel_login') || '{}')
  localStorage.clear()

  const channelStr = entryObject.channel || ''
  localStorage.setItem('entry', JSON.stringify({ href: window.location.href, time: +new Date() }))
  channelStr.length > 0 &&
    localStorage.setItem(
      'channel_login',
      JSON.stringify({ channel: channelStr, time: +new Date() })
    )

  const env = window.location.host.split('.')[0].split('-').pop() || ''

  const logoutUrlPre = `https://signin${ucur}.nio.com/logout?service=`
  const servicePre = `https://signin${ucur}.nio.com/oauth2/authorize?client_id=100119&redirect_uri=`
  const serviseEnd = `#/oauth_callback&response_type=code`
  const redirectUri =
    env.indexOf('localhost') !== -1
      ? `http://localhost:8002/pe/h5/static/chargermap`
      : window.location.origin + '/'
  const logoutUrl = `${logoutUrlPre}${encodeURIComponent(
    `${servicePre}${encodeURIComponent(redirectUri)}${serviseEnd}`
  )}`

  window.location.href = logoutUrl
}

export const getAuthorizeTicket = () =>
  fetch.get(`${prefix}auth/v1/gen/authorize/ticket`, {
    params: { origin },
  })

export const getAuthorizeToken = async () => {
  const parser = document.createElement('a')
  parser.href = (fetch.getGenFetch() as any).driver.adapter.url
  const ticket = await getAuthorizeTicket()
  const { code } = Object.assign({ code: '' }, ticket.data)
  const hostname = parser.hostname.replace('pe-fe-gateway', 'powerpro-api')
  const authorize = await fetch.get<{ access_token: string }>(
    `https://${hostname}/pe/powerpro/v1/sso/ticket/authorize`,
    {
      params: { app_id: 100119, ticket: code },
    }
  )
  return authorize?.data.access_token
}

export function checkLogin() {
  // 仅当 path 是 /oauth_callback 时才进行换取 access_token 的操作
  const ssoPath = '/oauth_callback'
  if (window.location.pathname === ssoPath || window.location.hash.startsWith(`#${ssoPath}`)) {
    const { search } = window.location
    const searchParams = new URLSearchParams(search)
    const params = Object.fromEntries(searchParams)
    searchParams.delete('code')
    const targetUrl =
      window.location.origin +
      '/' +
      window.location.pathname
        .split('/')
        .filter((path) => path)
        .join('/') +
      searchParams.toString() +
      window.location.hash
    window.history.replaceState({}, document.title, targetUrl)
    return apiSsoAccessToken(params).then((res: any) => {
      if (res.isValid()) {
        setTokens(res.data)
      }
      return res
    })
  }

  return Promise.resolve()
}
